import { ISimpleFetch } from '../../interfaces';

const defaultOptions: RequestInit = {
  credentials: 'include',
  cache: 'no-cache',
  headers: {
    'Content-Type': 'application/json',
  },
};

const parseJson = <T>(text: string): T => {
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error('Something went wrong');
  }
};

const parseErrorPayload = (text: string): unknown => {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

const simpleFetch = async <T = unknown>({
  uri,
  options = {},
  baseUrl = process.env.REACT_APP_API as string,
}: ISimpleFetch): Promise<T> => {
  const response = await fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options });
  const text = await response.text();

  if (response.ok) return parseJson<T>(text);

  throw parseErrorPayload(text);
};

const simplePost = async (url = '', data = {}, options = {}) => {
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...defaultOptions,
    ...options,
  });
  const parsedResponse = await response.json();
  if (!response.ok || parsedResponse?.error) throw parsedResponse;
  return parsedResponse;
};

export { simpleFetch, simplePost };
